export const PIECE_JOINTE_TYPE_LOGO = 'Logo';
export const PIECE_JOINTE_TYPE_HISTORIQUE_LOGO = 'Historique Logo';
export const PIECE_JOINTE_TYPE_LOGO_FACTURE = 'Logo facture';
export const PIECE_JOINTE_TYPE_LOGO_RELANCE_1 = 'Logo relance 1';
export const PIECE_JOINTE_TYPE_LOGO_RELANCE_2 = 'Logo relance 2';
export const PIECE_JOINTE_TYPE_LOGO_RELANCE_3 = 'Logo relance 3';
export const PIECE_JOINTE_TYPE_INSTRUCTION_POSE = 'Instruction de pose';
export const PIECE_JOINTE_TYPE_COMMANDE_SIGNEE = 'Commande signée';
export const PIECE_JOINTE_TYPE_COMMANDE_SIGNEE_ELECTRONIQUEMENT = 'Commande signée électroniquement';
export const PIECE_JOINTE_TYPE_ETIQUETTE_EXPEDITION = 'Etiquette d\'expédition';

export const FORMAT_ICON = ['ai', 'avi', 'css', 'doc', 'docx', 'eps', 'gif', 'html', 'jpg', 'mov', 'mp3', 'pdf', 'png', 'ppt', 'psd', 'rar', 'svg', 'txt', 'wav', 'xd', 'xlsx', 'xml', 'zip'];

export const FORMAT_ICON_DIVERS = 'divers';
export const MAX_TAILLE = 2048;
export const MAX_TAILLE_MINIATURE = 1024;

export const MODULE_LIGNE_COMMANDE = 'LigneCommande';
export const MODULE_DETAIL_FACE = 'DetailFace';
export const MODULE_CAMPAGNE = 'Campagne';
